<!-- 收藏的职位 -->
<template>
  <div class="collect">
    <!-- 导航栏 -->
    <van-nav-bar
      :title="type==0?'我收藏的职位':type==1?'浏览记录':'申请记录'"
      fixed
      placeholder
      z-index="10"
      @click-left="goBack"
    >
      <template #left>
        <img src="@/assets/img/position/back.png" class="back" />
      </template>
    </van-nav-bar>
    <!-- 列表项 -->
    <van-pull-refresh v-model="refreshing" @refresh="onRefresh">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
        <div
          class="list"
          @click="navDetails(item.job_id)"
          v-for="(item, index) in list"
          :key="index"
        >
          <div class="list-item">
            <span
              class="list-title"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.job_name}}</span>
            <span class="list-stop" v-if="item.open_status==0">停止招聘</span>
            <!-- item.interview_status==2?'面试通过':item.interview_status==3?'不合适':item.salary_type==1?'面议':`${item.min_salary}-${item.max_salary}`}} -->
            <span
              class="list-price"
              v-else
            >{{item.status==3?'不合适（简历未过初筛）':item.status==4?'面试取消':item.interview_status==2?'面试通过':item.interview_status==3?'不合适（面试完成）':item.salary_type==1?'面议':item.min_salary==item.max_salary?item.min_salary:`${item.min_salary}-${item.max_salary}`}}</span>
          </div>
          <div class="list-item">
            <span
              class="list-request"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.district_name}}</span>
            <span
              class="list-request"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.experience==0?'不限':item.experience}}</span>
            <span
              class="list-request"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.education==0?'不限':item.education}}</span>
            <span
              class="list-request"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.amount==0?'不限':`招${item.amount}人`}}</span>
          </div>
          <div class="list-item" :style="item.open_status==0?'color:#B3B3B3':''">
            {{item.tag==0?'还没有添加福利哦~':''}}
            <span
              class="list-welfare"
              v-for="(i, idx) in item.tag"
              :key="idx"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{i}}</span>
          </div>
          <div class="list-item">
            <img :src="item.company_logo" class="list-logo" />
            <span
              class="list-name"
              :style="item.open_status==0?'color:#B3B3B3':''"
            >{{item.company_name}}</span>
          </div>
          <div class="list-reasons" v-show="item.status==2&&item.interview_status==3">结果反馈：{{item.interview_reason}}</div>
          <div class="list-time">{{item.collect_time}}</div>
        </div>
      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import { getCollectList, getBrowseList, getApplyList } from "@/api/apiData";
import { Toast } from "vant";
// import { mapState } from "vuex";
export default {
  inject: ["Token"],
  components: {},
  data() {
    return {
      status: 0, //招聘状态  0 停止招聘  1 还在招聘
      type: "", //0 收藏  1  浏览记录 2 申请记录
      list: [],
      loading: false,
      finished: false,
      refreshing: false,
      page: 0,
      totalPages: 1,
      offset: 10
    };
  },
  computed: {
    // ...mapState(["token"])
  },
  methods: {
    //返回上一页
    goBack() {
      this.$router.back();
    },
    navDetails(id) {
      // if (val == 0) {
      //   this.$router.push({
      //     name: "positionDetails",
      //     params: {
      //       show: true
      //     }
      //   });
      // }
      this.$router.push({
        name: "positionDetails",
        query: {
          id: id
        }
      });
    },
    // 上拉加载
    onLoad() {
      this.getList();
    },
    // 下拉刷新
    onRefresh() {
      var that = this;
      that.page = 0;
      that.totalPages = 1;
      that.list = [];
      that.getList();
      that.loading = false;
      that.finished = false;
      setTimeout(() => {
        that.refreshing = false;
      }, 2000);
    },
    // 获取列表
    getList() {
      var that = this;
      var type = that.type;
      let { page, totalPages, offset, list } = that;
      let obj = {
        page: page + 1,
        offset: offset
      };
      if (totalPages > page) {
        switch (type) {
          case "0": //收藏的职位
            getCollectList(obj).then(res => {
              if (res.code == 1) {
                that.list = list.concat(res.data.list);
                that.totalPages = Math.ceil(Number(res.data.total) / offset);
                that.page = page + 1;
                if (res.data.list.length == 0) {
                  setTimeout(() => {
                    that.loading = false;
                    that.finished = true;
                  }, 2000);
                  return false;
                }
                if (that.list.length > list.length) {
                  setTimeout(() => {
                    that.loading = false;
                  }, 2000);
                }
              } else {
                // Toast(res.msg);
                setTimeout(() => {
                  that.$router.back();
                }, 2000);
              }
            });
            break;
          case "1": //浏览记录
            getBrowseList(obj).then(res => {
              if (res.code == 1) {
                that.list = list.concat(res.data.list);
                that.totalPages = Math.ceil(Number(res.data.total) / offset);
                that.page = page + 1;
                if (res.data.list.length == 0) {
                  setTimeout(() => {
                    that.loading = false;
                    that.finished = true;
                  }, 2000);
                  return false;
                }
                if (that.list.length > list.length) {
                  setTimeout(() => {
                    that.loading = false;
                  }, 2000);
                }
              } else {
                // Toast(res.msg)  ;
                setTimeout(() => {
                  that.$router.back();
                }, 2000);
              }
            });
            break;
          case "2": //申请记录
            getApplyList().then(res => {
              //(res);
              if (res.code == 1) {
                that.list = list.concat(res.data.list);
                that.totalPages = Math.ceil(Number(res.data.total) / offset);
                that.page = page + 1;
                if (res.data.list.length == 0) {
                  setTimeout(() => {
                    that.loading = false;
                    that.finished = true;
                  }, 2000);
                  return false;
                }
                if (that.list.length > list.length) {
                  setTimeout(() => {
                    that.loading = false;
                  }, 2000);
                }
              } else {
                // Toast(res.msg);
                setTimeout(() => {
                  that.$router.back();
                }, 2000);
              }
            });
            break;
        }
      } else {
        that.loading = false;
        that.finished = true;
      }
    }
  },
  created() {},
  mounted() {
    this.Token();
    this.type = this.$route.query.type;
    // this.getList();
  }
};
</script>
<style lang='less' scoped>
.collect {
  background: #f7f7f7;
  //   列表项
  .list {
    background: #fff;
    padding: 0.24rem 0.32rem 0;
    margin-top: 0.2rem;
    .list-item {
      width: 100%;
      display: flex;
      flex-wrap: wrap;
      align-items: center;
      position: relative;
      .list-title {
        display: flex;
        font-size: 0.36rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(50, 50, 50, 1);
      }
      // 停止招聘
      .list-price {
        font-size: 0.32rem;
        font-weight: bold;
        line-height: 1.5;
        color: rgba(255, 67, 67, 1);
        justify-items: flex-end;
      }
      .list-stop {
        font-size: 0.32rem;

        font-weight: bold;
        line-height: 45px;
        color: rgba(179, 179, 179, 1);
      }
      .list-request {
        display: flex;
        align-items: center;
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
      }
      .list-welfare {
        padding: 0.06rem 0.1rem;
        background: rgba(248, 248, 248, 1);
        border-radius: 0.04rem;
        color: rgba(77, 77, 77, 1);
        font-size: 0.24rem;
        margin-right: 0.16rem;
        margin-bottom: 0.1rem;
      }
      // .list-btn {
      //   padding: 0.09rem 0.32rem !important;
      //   line-height: 0.33rem;
      //   font-size: 0.24rem;
      //   color: rgba(255, 255, 255, 1);
      //   background: #ff4343;
      //   border-radius: 0.04rem;
      //   position: absolute;
      //   right: 0;
      // }

      // 已申请
      .applied {
        background: rgba(204, 204, 204, 1);
      }
      .list-logo {
        width: 0.36rem;
        height: 0.36rem;
        margin-right: 0.1rem;
      }
      .list-name {
        font-size: 0.24rem;
        font-weight: 400;
        line-height: 0.33rem;
        color: rgba(77, 77, 77, 1);
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 1;
        -webkit-box-orient: vertical;
      }
      .list-request::after {
        content: "";
        display: block;
        width: 0.02rem;
        height: 0.2rem;
        background: #4d4d4d;
        margin: 0 0.2rem;
      }
      .list-request:last-child::after {
        display: none;
      }
    }
    .list-reasons {
      font-size: 0.25rem;
      line-height: 1.5;
      color: #4d4d4d;
      padding-bottom: 0.1rem;
    }
    .list-item:nth-child(1) {
      justify-content: space-between;
    }
    .list-item:nth-child(2),
    .list-item:nth-child(4) {
      padding: 0.16rem 0;
    }
    .list-item:nth-child(3) {
      font-size: 0.3rem;
      color: rgba(77, 77, 77, 1);
    }
    .list-time {
      font-size: 0.22rem;
      font-weight: 400;
      line-height: 0.3rem;
      color: rgba(179, 179, 179, 1);
      text-align: left;
      border-top: 0.01rem solid rgba(229, 229, 229, 1);
      padding: 0.23rem 0;
    }
  }
}
</style>